import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Partials/Navbar";
import Sidebar from "./Partials/Sidebar";
import "@fontsource/work-sans"; // Defaults to weight 400
import "@fontsource/work-sans/400.css"; // Specify weight
import "@fontsource/work-sans/400-italic.css"; // Specify weight and style
import "bootstrap/dist/css/bootstrap.min.css";
import "./../../assets/css/dashboard.css";
import useAuthMiddleware from "../../useAuthMiddleware";
import { useSelector } from "react-redux";
import BroadcastMessageAdmin from "../../components/BroadcastMessage/BroadcastMessageAdmin";
import BroadcastMessage from "../../components/BroadcastMessage/BroadcastMessage";
import "./../../assets/css/moderator.css";

const DashboardLayout = () => {
  const { loading } = useAuthMiddleware();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isSidebarOpenMobile, setIsSidebarOpenMobile] = useState(false);
  const { userRoleInfo } = useSelector((state) => state.auth);



  if (loading) {
    return (
      <div
        className="d-flex-wrap justify-content-center align-items-center"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(255, 255, 255, 0.7)",
          zIndex: 9999,
        }}
      >
        <div
          className="spinner-border text-primary"
          style={{ width: "3rem", height: "3rem" }}
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="dashboard-layout">
      <div className="dashboard-top">
        <Navbar setIsSidebarOpenMobile={setIsSidebarOpenMobile} />
        <div>
          {userRoleInfo.isRoot ? <BroadcastMessageAdmin /> : <BroadcastMessage />}
        </div>
      </div>
  
      <div className="dashboard-body">
        {isSidebarOpenMobile && (
          <div
            className="sidebar-overlay"
            onClick={() => setIsSidebarOpenMobile(false)}
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.35)",
              zIndex: 1099,
            }}
          />
        )}
  
        <div className="sidebar-container">
          <Sidebar
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
            isSidebarOpenMobile={isSidebarOpenMobile}
            setIsSidebarOpenMobile={setIsSidebarOpenMobile}
          />
        </div>
  
        <div className="dashboard-main" id="main-content">
          <Outlet />
        </div>
      </div>
    </div>
  );
  
};

export default DashboardLayout;
